// extracted by mini-css-extract-plugin
export default {"container":"loginbox_container__1y0X+","centeredBox":"loginbox_centeredBox__AyLDu","link":"loginbox_link__LNGIX"};